<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { useVModel } from '@vueuse/core';

    const props = defineProps<{
        defaultValue?: string | number;
        modelValue?: string | number | File | null;
        class?: HTMLAttributes['class'];
    }>();

    const emits = defineEmits<{
        (e: 'update:modelValue', payload: string | number | File): void;
    }>();

    const modelValue = useVModel(props, 'modelValue', emits, {
        passive: true,
        defaultValue: props.defaultValue,
    });
</script>

<template>
    <input
        v-model="modelValue"
        data-slot="input"
        :class="
            cn(
                'file:text-foreground placeholder:text-faded-foreground/50 selection:bg-primary selection:text-primary-foreground border-input disabled:bg-muted flex h-7.5 w-full min-w-0 rounded-md border bg-transparent px-2.5 py-1 text-xs shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:border-0 file:bg-transparent file:pt-0.5 file:text-xs file:font-medium placeholder:text-xs',
                'disabled:bg-faded disabled:pointer-events-none disabled:cursor-not-allowed',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                props.class,
            )
        "
    />
</template>
